import Header from 'components/VerticalLayout/Header'
import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, Col, Container, FormGroup, Label, Row,Form, Modal, ModalHeader, ModalBody, Spinner } from 'reactstrap'
import PreviewTable from './PreviewTable'
import bgImage from "../../assets/images/bgImage1.jpg";
import IdentiAndMarketAreaAddForm from './IdentiAndMarketAreaAddForm';
import { IoIosArrowRoundBack } from "react-icons/io";
import RelativeCompForm from './RelativeCompForm';
import { useLocation, useNavigate } from 'react-router-dom';
import useRelativeMarketList from './useRelativeMarketList';
import { useForm } from 'react-hook-form';
import useGetPreSignedUrlAddDocs from './useGetPreSignedUrlAddDocs';
import useUploadCompletionAddDocs from './useUploadCompletionAddDocs';
import useGenerateFinalReport from './useGenerateFinalReport';
import ConfirmationModal from 'pages/Ui/Confirmation Modal/ConfirmationModal';
import useStatusConfirm from './useStatusConfirm';
import toast from 'react-hot-toast';
import { useQueryClient } from '@tanstack/react-query';
import useDownloadDraft from './useDownloadDraft';

const PreviewPage = () => {

    document.title = "Title Apprasier | Preview"

    const queryClient = useQueryClient();

    // getting preview data
    const location = useLocation();
    const {previewData, orderId,fileNumber,productType} = location.state || {};
    console.log("previewData", previewData)
    console.log("orderId in pre page",orderId)

    // handling modal
    // identifiaction and market ananlysis
    const[isIdenFormOpen, setIsIdenFormOpen]=useState(false)
    // relative comparitive analysis
    const[isOpenRelativeComp, setIsOpenRelativeComp]=useState(false)
    // navigate
    const navigate = useNavigate();

    // on close for modal
    const closeIdentificationModal=()=>{
        setIsIdenFormOpen(false)
    }
    // custom hook to get the identification and market data
    // const{isPending, isSuccess, isError, error, fetchedData}= useRelativeMarketList(orderId,previewData[0].id)
    const[subjData,setSubjData] = useState('')
    useEffect(()=>{
        if(previewData){
            setSubjData(previewData[0].id)
        }
        else{
            setSubjData(null)
        }
    },[previewData])

    const{register,handleSubmit,formState:{errors},reset,watch,setValue} = useForm({
        defaultValues:{
            additionalDocOne:"",
        },
        criteriaMode:"all",
        mode:"onChange"
    })

    

    // custom hook for getting presigend url
    const{isGetting,isGot,getPreSignedUrl} = useGetPreSignedUrlAddDocs();
    // cusotm hook for upload completion
    const{isLoading,isDone,uploadCompletionAddDocs} = useUploadCompletionAddDocs();
    // hook for generating the final report
    const{isGenerating,isGenerated,generateReport,data: reportData} = useGenerateFinalReport();
    // hook for generating and downloading the draft
    const{isDownloadingDraft,DraftDownloaded,downloadDraft,data: draftData} = useDownloadDraft()

    // handling the confirmation modal and api call
    const[modalOpen,setModalOpen] = useState(false);
    const toggleModal=()=> setModalOpen(!modalOpen);

    // hook to call the statsu change api after the final report genertation
    const{isChanging, isChanged, updateFinalStatus} = useStatusConfirm();

    // for make the button loading and disable
    const [isUploading, setIsUploading] = useState(false);

    const onSubmit=async(data)=>{
        console.log("additional docs",data)
        setIsUploading(true);
        try{
            let additional_docs = [];
        // additional doc one
        if (data.additionalDocOne && data.additionalDocOne.length >0){
            const uploadPromises = Array.from(data.additionalDocOne).map(async (file)=>{

                const additionalDocOneRes = await getPreSignedUrl({orderId:orderId,file_name:file.name,content_type:file.type});
                    await fetch(additionalDocOneRes.upload_url,{
                        method:'PUT',
                        headers:{
                            'Content-Type': file.type,
                        },
                        body:file
                    })

                    return additionalDocOneRes.view_url;
            })

            additional_docs = await Promise.all(uploadPromises);
        }
        
        console.log("final list of urls",additional_docs)
        
        if(additional_docs && additional_docs.length > 0){
            const payload={
                orderId:orderId,
                additional_docs:additional_docs
            }
            uploadCompletionAddDocs(payload)
        }
        }finally{
            setIsUploading(false)
        }
        
    }

    const handleGenerateReport=()=>{
        console.log("generating")
        toggleModal();
        if(orderId){
            updateFinalStatus(orderId)
        }
    }

    // use effect for opening the final doc preview
    useEffect(()=>{
        if(isGenerated && reportData?.preview_url){
            console.log("Report generated successfully. Opening preview URL:", reportData.preview_url);
            window.open(reportData.preview_url, '_blank');
            // toggleModal();
            queryClient.invalidateQueries(['orderList'])
            navigate('/dashboard')

        }
    },[isGenerated,reportData,queryClient,navigate])
    
    // for downloading the draft
    const handleDownloadDraft=()=>{
        // console.log("order id",orderId)
        downloadDraft(orderId,{
            onSuccess:(data)=>{
                const url = data.preview_url;
                const link = document.createElement('a');
                    link.href = url;
                    // link.setAttribute('download', 'Draft Report.pdf');
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
            },
            onError:(err)=>{
                // alert('Download failed');
                toast.error('Download Failed')
                console.error(err);
            }
        })
    }


  return (
    <div className='account-pages'>
        <Header/>
        <div className='accountbg'
            style={{
            background: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundAttachment:"fixed",
            paddingTop:"80px",
            minHeight:"100vh",
            overflow:"auto",
            paddingLeft:"8px"
            }}
        >
          <Container fluid>
            <Row>
              <Col>
                  <Card style={{backdropFilter:"blur(10px)",opacity:"1"}}>
                    <PreviewTable previewData={previewData} orderId={orderId} fileNumber={fileNumber}/>

                    <CardBody>
                        <div style={{display:"flex",flexDirection:"row",alignItems:"center",justifyContent:"center",gap:"1.5rem"}}>
                            <Button className="btn py-2" style={{ backgroundColor: "#00ADF0", color: "white", minWidth: "150px", fontWeight: "bolder" }}
                                onClick={()=> setIsIdenFormOpen(prev=> !prev)}
                            >
                                Identification & Market Area
                            </Button>
                            <Button className="btn py-2" style={{ backgroundColor: "#00ADF0", color: "white", minWidth: "150px", fontWeight: "bolder" }}
                                onClick={()=> setIsOpenRelativeComp(prev => !prev)}
                            >
                                Relative Comparitive Analysis
                            </Button>
                        </div>
                        <Row className='mt-4'>
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                <Row style={{display:"flex", flexDirection:"row", alignItems:"center", justifyContent:"center"}}>
                                    <Col md={3}>
                                        <FormGroup>
                                            <Label htmlFor='additionalDocOne' className='form-label'>Additional Documents</Label>
                                            <input
                                                type='file'
                                                multiple
                                                id='additionalDocOne'
                                                name='additionalDocOne'
                                                className='form-control border-primary-subtle'
                                                accept='application/pdf'
                                                {...register("additionalDocOne",{
                                                    validate:{
                                                        isPdf: (files)=>{
                                                            if(!files || files.length === 0) return true;
                                                            for (let file of files){
                                                                if(file.type !="application/pdf"){
                                                                    return "File type not supported — upload a PDF"
                                                                }
                                                            }
                                                            return true;
                                                        }
                                                    }
                                                })}
                                            />
                                        </FormGroup>
                                        {errors.additionalDocOne && <span className="text-danger">{errors.additionalDocOne.message}</span>}
                                    </Col>
                                </Row>

                                <div className='mt-3' style={{display:"flex",flexDirection:"row",alignItems:"center",justifyContent:"center",gap:"1.5rem"}}>
                                    <Button className="btn py-2" style={{ backgroundColor: "#00ADF0", color: "white", minWidth: "150px", fontWeight: "bolder" }}
                                        onClick={()=> navigate(-1)}
                                    ><IoIosArrowRoundBack />Back</Button>

                                    <Button className="btn py-2" style={{ backgroundColor: "#00ADF0", color: "white", minWidth: "150px", fontWeight: "bolder" }} type='submit'
                                        disabled={isUploading}
                                    >
                                        {isUploading ? <Spinner size='sm'/> :'Add Docs'}
                                    </Button>
                                    
                                    <Button className="btn py-2" style={{ backgroundColor: "#00ADF0", color: "white", minWidth: "150px", fontWeight: "bolder" }}
                                        disabled={isUploading||isGenerating || isDownloadingDraft} onClick={handleDownloadDraft}
                                    >
                                        {isDownloadingDraft ? <Spinner size='sm'/> : 'Download Draft'}
                                    </Button>

                                    <Button className="btn py-2" style={{ backgroundColor: "#00ADF0", color: "white", minWidth: "150px", fontWeight: "bolder" }}
                                        disabled={isUploading||isGenerating} onClick={handleGenerateReport}
                                    >
                                        {isGenerating ? <Spinner size='sm'/> : 'Generate Final Report'}
                                    </Button>
                                </div>
                            </Form>
                        </Row>
                    </CardBody>
                  </Card>
              </Col>
            </Row>
            
            {/* modal for identification and market area */}
            <Modal
                isOpen={isIdenFormOpen}
                size='xl'
                backdrop="static"
                keyboard={false}
                toggle={()=>setIsIdenFormOpen(prev => !prev)}
                fullscreen='xl'
                fade
                scrollable
            >
                <ModalHeader 
                    close={
                        <button type='button' className='btn-close'
                            onClick={()=>setIsIdenFormOpen(prev=> !prev)}
                        />
                    }
                >
                    Identification and Market Area
                </ModalHeader>
                <ModalBody>
                    <IdentiAndMarketAreaAddForm
                        orderId={orderId}
                        id={subjData} 
                        onClose={closeIdentificationModal}
                    />
                </ModalBody>
            </Modal>

            {/* modal for relative comparitive analysis */}
            <Modal
                isOpen={isOpenRelativeComp}
                size='xl'
                backdrop='static'
                keyboard={false}
                toggle={()=> setIsOpenRelativeComp(prev => !prev)}
                fullscreen='xl'
                fade
                scrollable
            >
                <ModalHeader
                    close={
                        <button type='button' className='btn-close'
                            onClick={()=>setIsOpenRelativeComp(prev => !prev)}
                        />
                    }
                >
                    Analysis Details
                </ModalHeader>
                <ModalBody>
                    <RelativeCompForm
                        orderId={orderId}
                        onClose={()=> setIsOpenRelativeComp(prev => !prev)}
                    />
                </ModalBody>
            </Modal>

            {/* confirmation modal  for changing the status as completed after generating the report*/}
            <ConfirmationModal 
                open={modalOpen}
                toggle={toggleModal}
                // onConfirm={()=>updateFinalStatus(orderId)}
                onConfirm={()=>generateReport({orderId,productType})}
                title="Confirmation"
                message="You won't be able to edit this order after generating the final PDF. Are you sure you want to proceed?"
            />
          </Container>
        </div>
      </div>
  )
}

export default PreviewPage